import TokenizeData from "./TokenizeData";
const tokenizeData={
     TokenizeData
}
export default tokenizeData